import React from 'react';
import './Styles/Banner.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import {ReactComponent as Video} from '../../../Assets/Icons/video.svg';
import image from '../../../Assets/Cards/wireframeimg.webp';
const Banner=()=>{
    return(
        <div className="wireframe-banner">
            <div className="content">
                <h1>A wireframing tool that gets you to the best idea, fast</h1>
                <p>Create low-fidelity wireframes inside HostDesign with simple drag & drop tool.</p>
            </div>
            <img src={image} />
        </div>
    )
};
export default Banner ;